import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { TherapistForm } from "./TherapistForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

type SiteOption = { id: number; name: string }

type Props = PageProps & {
  sites: SiteOption[]
  photo_library: LibraryPhoto[]
}

const BLANK_THERAPIST = {
  name: "",
  slug: "",
  email: "",
  speciality_en: "",
  speciality_es: "",
  bio_en: "",
  bio_es: "",
  website_url: "",
  status: "pending",
  listed_at: null,
  site_ids: [],
  photo_url: null,
  specialisms: [],
  qualifications: [],
  accreditations: [],
  training: [],
  languages: [],
  approach_cbt: "",
  approach_emdr: "",
  approach_closing: "",
  what_to_expect: "",
}

export default function TherapistsNew() {
  const { props } = usePage<Props>()

  return (
    <AdminShell>
      <Head title="Add Therapist">
        <meta name="description" content="Add a new therapist profile to Sanctuary Therapy Centre." />
        <meta property="og:title" content="Add Therapist" />
        <meta property="og:description" content="Add a new therapist profile to Sanctuary Therapy Centre." />
      </Head>
      <Breadcrumbs
        items={[{ label: "Website Pages", href: "/admin/website" }, { label: "New therapist" }]}
      />
      <PageHeader title="Add Therapist" />
      <div className="mt-8 max-w-2xl">
        <TherapistForm
          therapist={BLANK_THERAPIST}
          sites={props.sites}
          actionUrl="/admin/therapists"
          method="post"
          photoLibrary={props.photo_library}
        />
      </div>
    </AdminShell>
  )
}
